import _ from 'lodash';
import React, { Component } from 'react';
import './App.css';
import { Footer } from './Footer';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import { MapComponent } from './MapSectional';
import cx from 'classnames';
import { connect } from 'react-redux';
import {
  updateQuadrantI,
  toggleSlider
} from './MapSectional/Map.action';

import { calculateValue, calculateGradient } from './utils';

const drawerWidth = 240;

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit,
    zIndex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  },
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden'
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  content: {
    flexGrow: 1,
    display: 'block',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },
  colorbarLeftClosed: {
    cursor: 'crosshair',
    position: 'absolute',
    bottom: 25,
    left: 0,
    height: 25,
    width: '100%',
    transition: theme.transitions.create(['left', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  colorbarLeftOpened: {
    cursor: 'crosshair',
    position: 'absolute',
    bottom: 25,
    left: drawerWidth,
    height: 25,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['left', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  productValue: {
    color: '#FFFFFF',
    fontSize: 14,
    margin: '8px 4px'
  },
  rootMenu: {
    width: '100%',
    maxWidth: drawerWidth,
    backgroundColor: theme.palette.background.paper,
    paddingBottom: 25
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class Radar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leftOpen: true,
      colorHover: false,
      hoverValue: '',
      newOffset: 0,
      refOpen: false,
      velOpen: false,
      srvOpen: false,
      swOpen: false,
      drOpen: false,
      ccOpen: false,
      sdpOpen: false,
      ref2Open: false,
      vel2Open: false,
      sw2Open: false,
      dr2Open: false,
      cc2Open: false,
      dp2Open: false,
      tvsChecked: false,
      etOpen: false,
      dvlOpen: false
    };

    this.handleLeftDrawerOpen = this.handleLeftDrawerOpen.bind(this);
    this.handleLeftDrawerShut = this.handleLeftDrawerShut.bind(this);
    this.toggleSlider = this.toggleSlider.bind(this);

    this.handleRefClick = this.handleRefClick.bind(this);
    this.handleVelClick = this.handleVelClick.bind(this);
    this.handleSrvClick = this.handleSrvClick.bind(this);
    this.handleSwClick = this.handleSwClick.bind(this);
    this.handleDrClick = this.handleDrClick.bind(this);
    this.handleCcClick = this.handleCcClick.bind(this);
    this.handleSdpClick = this.handleSdpClick.bind(this);
    this.handleRef2Click = this.handleRef2Click.bind(this);
    this.handleVel2Click = this.handleVel2Click.bind(this);
    this.handleSw2Click = this.handleSw2Click.bind(this);
    this.handleDr2Click = this.handleDr2Click.bind(this);
    this.handleCc2Click = this.handleCc2Click.bind(this);
    this.handleDp2Click = this.handleDp2Click.bind(this);
    this.handleTvsToggle = this.handleTvsToggle.bind(this);
    this.handleEtClick = this.handleEtClick.bind(this);
    this.handleDvlClick = this.handleDvlClick.bind(this);
  }

  handleRefClick() { this.setState({ refOpen: !this.state.refOpen }); }
  handleVelClick() { this.setState({ velOpen: !this.state.velOpen }); }
  handleSrvClick() { this.setState({ srvOpen: !this.state.srvOpen }); }
  handleSwClick() { this.setState({ swOpen: !this.state.swOpen }); }
  handleDrClick() { this.setState({ drOpen: !this.state.drOpen }); }
  handleCcClick() { this.setState({ ccOpen: !this.state.ccOpen }); }
  handleSdpClick() { this.setState({ sdpOpen: !this.state.sdpOpen }); }
  handleRef2Click() { this.setState({ ref2Open: !this.state.ref2Open }); }
  handleVel2Click() { this.setState({ vel2Open: !this.state.vel2Open }); }
  handleSw2Click() { this.setState({ sw2Open: !this.state.sw2Open }); }
  handleDr2Click() { this.setState({ dr2Open: !this.state.dr2Open }); }
  handleCc2Click() { this.setState({ cc2Open: !this.state.cc2Open }); }
  handleDp2Click() { this.setState({ dp2Open: !this.state.dp2Open }); }
  handleTvsToggle() { this.setState({ tvsChecked: !this.state.tvsChecked }); }
  handleEtClick() { this.setState({ etOpen: !this.state.etOpen }); }
  handleDvlClick() { this.setState({ dvlOpen: !this.state.dvlOpen }); }
  handleLeftDrawerOpen() { this.setState({ leftOpen: true }); }
  handleLeftDrawerShut() { this.setState({ leftOpen: false }); }
  changeQuadrantI(product) { this.props.updateQuadrantI(product); }
  mouseEnter() { this.setState({ colorHover: true }); }
  mouseLeave() { this.setState({ colorHover: false }); }

  mouseMove(event) {
    if (this.state.colorHover) {
      const currentTargetRect = event.currentTarget.getBoundingClientRect();
      const event_offsetX = event.pageX - currentTargetRect.left;
      const xPos = event_offsetX;
      this.setState({
        newOffset: ((currentTargetRect.width / 2) - xPos) * -1.0,
        hoverValue: `${Math.round(calculateValue(this.props.quadrantI.selectedColor, xPos, currentTargetRect.width) * 1000) / 1000}${this.props.quadrantI.units}`
      });
    }
  }

  toggleSlider() {
    this.props.toggleSlider();
  }

  render() {
    const { classes } = this.props;
    const { leftOpen } = this.state;

    return (
      <div className={ classes.root }>
        <CssBaseline />
        <AppBar
          position='fixed'
          className={
            cx(classes.appBar, {
              [classes.appBarShift]: leftOpen
            })
          }
        >
          <Toolbar disableGutters={ !leftOpen }>
            <IconButton
              color='inherit'
              aria-label='Open drawer'
              onClick={ this.handleLeftDrawerOpen }
              className={
                cx(classes.menuButton, leftOpen && classes.hide)
              }
            >
              <MenuIcon />
            </IconButton>
            <Typography variant='h6' color='inherit' noWrap>
              Nexview.io
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          className={ classes.drawer }
          variant='persistent'
          anchor='left'
          open={ leftOpen }
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <div className={ classes.drawerHeader }>
            <IconButton onClick={ this.handleLeftDrawerShut }>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List
            component='nav'
            subheader={ <ListSubheader component="div">Level II Products</ListSubheader> }
            className={ classes.rootMenu }
          >
            <ListItem button onClick={ this.handleRef2Click }>
              <ListItemText primary='Reflectivity' />
              { this.state.ref2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.ref2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref2') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref4') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref6') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref7') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref8') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref9') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref10') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref11') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'ref12') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleVel2Click }>
              <ListItemText primary='Radial Velocity' />
              { this.state.vel2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.vel2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel1') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel2') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel3') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel4') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel5') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel6') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel7') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel8') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'vel9') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleSw2Click }>
              <ListItemText primary='Spectrum Width' />
              { this.state.sw2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.sw2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw1') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw2') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw3') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw4') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw5') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw6') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw7') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw8') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'sw9') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleDr2Click }>
              <ListItemText primary='Differential Reflectivity' />
              { this.state.dr2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.dr2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr1') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr2') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr3') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr4') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr5') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr6') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr7') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr8') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dr9') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleCc2Click }>
              <ListItemText primary='Correlation Coefficient' />
              { this.state.cc2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.cc2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc1') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc2') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc3') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc4') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc5') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc6') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc7') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc8') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'cc9') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleDp2Click }>
              <ListItemText primary='Differential Phase Shift' />
              { this.state.dp2Open ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.dp2Open } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp0') } className={ classes.nested }>
                  <ListItemText primary='Sweep I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp1') } className={ classes.nested }>
                  <ListItemText primary='Sweep II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp2') } className={ classes.nested }>
                  <ListItemText primary='Sweep III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp3') } className={ classes.nested }>
                  <ListItemText primary='Sweep IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp4') } className={ classes.nested }>
                  <ListItemText primary='Sweep V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp5') } className={ classes.nested }>
                  <ListItemText primary='Sweep VI' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp6') } className={ classes.nested }>
                  <ListItemText primary='Sweep VII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp7') } className={ classes.nested }>
                  <ListItemText primary='Sweep VIII' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp8') } className={ classes.nested }>
                  <ListItemText primary='Sweep IX' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dp9') } className={ classes.nested }>
                  <ListItemText primary='Sweep X' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />
          </List>
          <List
            component='nav'
            subheader={ <ListSubheader component="div">Level III Products</ListSubheader> }
            className={ classes.rootMenu }
          >
            <ListItem button onClick={ this.handleRefClick }>
              <ListItemText primary='Reflectivity' />
              { this.state.refOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.refOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0q') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1q') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2q') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3q') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleVelClick }>
              <ListItemText primary='Velocity' />
              { this.state.velOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.velOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0u') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1u') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2u') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3u') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleSrvClick }>
              <ListItemText primary='Storm Relative Velocity' />
              { this.state.srvOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.srvOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0s') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1s') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2s') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3s') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleSwClick }>
              <ListItemText primary='Spectrum Width' />
              { this.state.swOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.swOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nsp') } className={ classes.nested }>
                  <ListItemText primary='32 nm' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nsw') } className={ classes.nested }>
                  <ListItemText primary='124 nm' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleDrClick }>
              <ListItemText primary='Differential Reflectivity' />
              { this.state.drOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.drOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0x') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nax') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1x') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nbx') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2x') } className={ classes.nested }>
                  <ListItemText primary='Tilt V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3x') } className={ classes.nested }>
                  <ListItemText primary='Tilt VI' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleCcClick }>
              <ListItemText primary='Correlation Coefficient' />
              { this.state.ccOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.ccOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0c') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nac') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1c') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nbc') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2c') } className={ classes.nested }>
                  <ListItemText primary='Tilt V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3c') } className={ classes.nested }>
                  <ListItemText primary='Tilt VI' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleSdpClick }>
              <ListItemText primary='Specific Differential Phase' />
              { this.state.sdpOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.sdpOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n0k') } className={ classes.nested }>
                  <ListItemText primary='Tilt I' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nak') } className={ classes.nested }>
                  <ListItemText primary='Tilt II' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n1k') } className={ classes.nested }>
                  <ListItemText primary='Tilt III' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'nbk') } className={ classes.nested }>
                  <ListItemText primary='Tilt IV' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n2k') } className={ classes.nested }>
                  <ListItemText primary='Tilt V' />
                </ListItem>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'n3k') } className={ classes.nested }>
                  <ListItemText primary='Tilt VI' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleEtClick }>
              <ListItemText primary='Echo Tops' />
              { this.state.etOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.etOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'eet') } className={ classes.nested }>
                  <ListItemText primary='Enhanced Echo Tops' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />

            <ListItem button onClick={ this.handleDvlClick }>
              <ListItemText primary='Vertical Integrated Liquid' />
              { this.state.dvlOpen ? <ExpandLess /> : <ExpandMore /> }
            </ListItem>
            <Collapse in={ this.state.dvlOpen } timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem button onClick={ this.changeQuadrantI.bind(this, 'dvl') } className={ classes.nested }>
                  <ListItemText primary='Digital VIL' />
                </ListItem>
              </List>
            </Collapse>
            <Divider />
          </List>
          {/* <List
            component='nav'
            subheader={ <ListSubheader component="div">Overlay Products</ListSubheader> }
            className={ classes.rootMenu }
          >
            <ListItem button onClick={ this.handleTvsToggle }>
              <Checkbox
                checked={ this.state.tvsChecked }
                tabIndex={ -1 }
                disableRipple
                color='default'
              />
              <ListItemText primary='TVS' />
            </ListItem>
          </List> */}
        </Drawer>
        <main
          className={
            cx(classes.content, {
              [classes.contentShift]: leftOpen
            })
          }
        >
          <div className={ classes.drawerHeader } />
          <div>
            <MapComponent
              lng={ -96.5634227 }
              lat={ 39.218219 }
              zoom={ 4.75 }
            />
            { this.props.enableSlider ? null :
              <Tooltip
                title={
                  <React.Fragment>
                    <span
                      className={ classes.productValue }
                      dangerouslySetInnerHTML={{
                        __html: this.state.hoverValue
                      }}
                    />
                  </React.Fragment>
                }
                PopperProps={{
                  popperOptions: {
                    modifiers: {
                      offset: {
                        offset: this.state.newOffset
                      }
                    }
                  }
                }}
              >
                <div
                  onMouseEnter={ this.mouseEnter.bind(this) }
                  onMouseLeave={ this.mouseLeave.bind(this) }
                  onMouseMove={ this.mouseMove.bind(this) }
                  className={ leftOpen ? classes.colorbarLeftOpened : classes.colorbarLeftClosed }
                  style={{
                    background: `linear-gradient(to right, ${ calculateGradient(this.props.quadrantI.selectedColor).join() }`
                  }}
                />
              </Tooltip>
              }
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    quadrantI: {
      product: state.mapReducer.quadrantI.product,
      units: state.mapReducer.quadrantI.units,
      selectedColor: state.mapReducer.quadrantI.selectedColor
    },
    site: state.mapReducer.site,
    latitude: state.mapReducer.lat,
    longitude: state.mapReducer.lon,
    metadata: state.mapReducer.properties
  };
};

export default connect(mapStateToProps, {
  updateQuadrantI,
  toggleSlider
})(withStyles(styles)(Radar));